import React, { Component } from 'react';
import _ from 'lib/lodash'

import ACL from 'components/common/ACL'
import fileSize from 'filesize'
import FontIcon from 'react-md/lib/FontIcons/FontIcon';
import MenuButton from 'react-md/lib/Menus/MenuButton';
import Button from 'react-md/lib/Buttons'
import ListItem from 'react-md/lib/Lists/ListItem';
import Divider from 'react-md/lib/Dividers'

import TextFieldEdit from 'components/common/TextFieldEdit'

import LoadingSpinnerSmall from 'components/common/LoadingSpinnerSmall'

import './DocumentCardItem.css'

import PDFIcon from 'img/adobe-pdf-icon.svg'

class DocumentCardItem extends Component {
	state = {
		isEditing: false,
	};

	handleMenuOpen = (e) => {
		const { node } = this.props;
		const fileUrl = _.get(node, 'storage.fileUrl');

		if (fileUrl) window.open(fileUrl);
	};

	handleMenuEdit = () => this.setState({ ...this.state, isEditing: true });

	handleMenuEditExit = () => {
		const { actionHandler } = this.props;

		this.setState({...this.state, isEditing: false}, );
		actionHandler.addToast("Änderungen gespeichert");
	};

	handleMenuDelete = e => {
		const { node, actionHandler } = this.props;
		const { deleteNodeFromPayload, addToast } = actionHandler;

		deleteNodeFromPayload(node).then(() => addToast("Dokument gelöscht"));
	};

	updateProperty = (property) => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		changeNodeProperty(node, property);
	};

	render() {
		const { node, actionHandler, aclAllow } = this.props;
		const { nodeHandler } = actionHandler;
		const isDeleting = nodeHandler.isDeleting && nodeHandler.currentNode.$id === node.$id;
		const { properties } = node;
		const { isEditing } = this.state;

		const { title } = properties;
		const subtitle = `${fileSize(node.storage.totalSize)}`;
		const fileUrl = _.get(node, 'storage.fileUrl');

		const menuItems = [
			<ACL allow={aclAllow.edit} key="open">
				{ isEditing && <ListItem
					key="open"
					primaryText="Dokument öffnen"
					leftIcon={<FontIcon>description</FontIcon>}
					onClick={this.handleMenuOpen}
				/> }
				{ isEditing && <Divider /> }
				<ListItem
					primaryText="Löschen"
					leftIcon={<FontIcon>delete</FontIcon>}
					onClick={this.handleMenuDelete}
				/>
			</ACL>
		];

		const renderMenu = () => (
			<ACL allow={aclAllow.edit}>
				<div className="card-button-container">
					{ !isEditing && <Button icon onClick={this.handleMenuEdit}>edit</Button> }
					<MenuButton
						key="menu"
						id={`vert-menu${node.$id}`}
						icon
						menuItems={menuItems}
						simplifiedMenu={false}
						anchor={{
							x: MenuButton.HorizontalAnchors.LEFT,
							y: MenuButton.VerticalAnchors.OVERLAP,
						}}
					>
						<FontIcon>more_vert</FontIcon>
					</MenuButton>
				</div>
			</ACL>
		);

		const renderActionButtons = () => (
			<div className="document-actions">
				<img className="document-icon" alt="PDF" src={properties.icon ? properties.icon.src : PDFIcon} onClick={this.handleMenuOpen} />
			</div>
		);

		const renderTitle = () => (
			<div>
				{ isEditing && <TextFieldEdit
					id="title-field-document"
					placeholder="Titel setzen"
					type="title"
					label="Titel"
					value={title}
					rightIcon={<FontIcon className="icon-done" onClick={this.handleMenuEditExit}>done</FontIcon>}
					onSubmit={value => this.updateProperty({ title: value })}
				/> }
				{ !isEditing && title && <a href={fileUrl} id={`node:${node.$id}:document:${title}`} target="_blank" rel="noopener noreferrer" className="link">{title}</a> }
			</div>
		);

		const renderSubtitle = () => (
			<span className="link" onClick={this.handleMenuOpen}>{subtitle}</span>
		);

		const renderContent = () => (
			<div className="document-card-item" id={node.$id}>
				<ListItem
					ref={c => this.listItem = c}
					primaryText={renderTitle()}
					secondaryText={renderSubtitle()}
					leftIcon={renderActionButtons()}
					rightIcon={renderMenu()}
					disabled
				>
				</ListItem>
			</div>
		);

		const renderIsDeleting = () => <LoadingSpinnerSmall message="Dokument wird gelöscht..." />;

		return (
			<div className="document-card-item-container">
				{!isDeleting ? renderContent() : renderIsDeleting()}
				<Divider className="document-card-item-divider"/>
			</div>
		)
	}
}

export default DocumentCardItem;




// WEBPACK FOOTER //
// ./src/components/cards/document/v1/DocumentCardItem.jsx